<template>
  <v-tabs>
    <v-tab v-if="Boolean(client)">Profile</v-tab>
    <v-tab v-if="Boolean(client) && isAdmin"> Plans </v-tab>
    <v-tab v-if="Boolean(client)">Schools</v-tab>
    <v-tab v-show="Boolean(client)">Client Chart</v-tab>
    <v-tab v-if="Boolean(client) && isAdmin">Case Notes</v-tab>
    <v-tab-item v-if="Boolean(client)">
      <client-profile :client="client" :viewOnly="viewOnly"></client-profile>
    </v-tab-item>
    <v-tab-item v-if="Boolean(client) && isAdmin">
      <client-plans :client="client" :viewOnly="viewOnly"></client-plans>
    </v-tab-item>
    <v-tab-item v-if="Boolean(client)">
      <client-schools-table :viewOnly="viewOnly"></client-schools-table>
    </v-tab-item>
    <v-tab-item>
      <client-chart :client="client" :viewOnly="viewOnly"></client-chart>
    </v-tab-item>
    <v-tab-item>
      <case-notes></case-notes>
    </v-tab-item>
  </v-tabs>
</template>

<script>
import ClientProfile from "../Details/client-profile";
import ClientPlans from "../Details/client-plans";
import ClientSchoolsTable from "../Details/client-schools-table";
import ClientChart from "./client-chart";
import CaseNotes from "./case-notes";
export default {
  props: ["client", "viewOnly"],
  components: {
    ClientProfile,
    ClientPlans,
    ClientSchoolsTable,
    ClientChart,
    CaseNotes,
  },
  computed: {
    isAdmin() {
      return this.$store.getters["securityModule/isAdmin"];
    },
  },
};
</script>
